@if (element?.verificationMeter) {
  <form [formGroup]="form">
    <app-input-group>
      <label appLabel>{{ 'common.date.validfrom' | translate }}</label>
      <input type="date" appInputDate formControlName="validFrom">
    </app-input-group>
  </form>
}
